<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs v-if="fill === 'gradient'">
      <linearGradient id="gradient" x1="0%" y1="0%" x2="50%" y2="50%">
        <stop offset="0" stop-color="#FF00D6" />
        <stop offset="100%" stop-color="#0072DB" />
      </linearGradient>
    </defs>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.502 9.39295L15.5 9.05176V8.0127L14.502 8.35389V4H12.6904V8.97319L11.7607 9.29102V10.3301L12.6904 10.0123V14.5H14.502V9.39295ZM11.0771 14.5V13.0781H7.26048L10.9473 8.18359V7.10352H10.2842H9.73047H5.0957V8.53223H8.65466L5 13.3857V14.5H5.5127H6.18945H11.0771Z"
      :fill="fill === 'gradient' ? 'url(#gradient)' : fill"
    />
  </svg>
</template>
<script>
export default {
  props: {
    fill: {
      type: String,
      default: "white",
    },
  },
};
</script>
